<template>
	
	<div id="factsheet" :class="classes">

		<router-view :key="$route.path" />

	</div>

</template>

<script>

export default {
  name: 'FactsheetLayout',
  components: {

  },
  props : {
  	
  },
  data () {
    return {
    	classes : [] , 
      md : {} , 
      is_mobile : false
    }
  },
  mounted () { 
  	
  },
  watch: { 

  },
  methods: {
    
  }
}
</script>

<style lang="scss">

// Import from master-IARC new template : see (style.css to see import or import directly style.css)
$font_family : "Object Sans", sans-serif ;

@import '@/csu-vue-components/themes/iarc_new/assets/_variables.scss' ;

@import '@/csu-vue-components/themes/iarc_new/assets/base-new.css' ;
@import '@/csu-vue-components/themes/iarc_new/assets/header-vertical.css' ;
@import '@/csu-vue-components/themes/iarc_new/assets/header-home-page.css' ;
@import '@/csu-vue-components/themes/iarc_new/assets/new-design.css' ;
@import '@/csu-vue-components/themes/iarc_new/assets/bootstrap.v5.2.min.css' ;

@import '@/csu-vue-components/themes/iarc_new/assets/css/icomoon.css' ;
@import '@/csu-vue-components/themes/iarc_new/assets/graphic.scss' ; 

/* Custom additional css */

$box_shadow : 0 ; /* 0px 5px rgba(0, 0, 0, 0.1) ;*/
$border_radius: 3px ;
$border_solid : solid 1px #ccc ; 
$font_table : 'Arial' !important ;

.incidence{
  background-color: #0455A1;
}
.mortality,#factsheet .factsheet_content .factsheet_page table tr.row_line.mortality{
  background-color: #D91715;
}
.prevalence{
  background-color: #066D2C;
}
.economics{
  background-color: #F4BA0C ;
}


.incidence_border{
  border-color: #0455A1;
}
.mortality_border{
  border-color: #D91715;
}
.prevalence_border{
  border-color: #066D2C;
}

html.fact-sheet-cancer,html.fact-sheet-population{

  .cc-window{
    display: none;
  }

}

#factsheet{
  overflow-x: hidden;
  overflow-y: hidden;

  .factsheet_content{
    position: relative ; 
    &.factsheet_economics{
      .factsheet_page{
        .number_at_glance{
          h2{
            font-size: 20px;
          }
          span.num{
            font-size: 36px;
          }
          height: 180px;
        }
      }
    }

    .factsheet_page{
      width: 1400px ; 
      height: 1980px; 
      position: relative;

      .heading_top_population{
        position: absolute;
        height: 300px;
        width: 105%;
        left: -15px;
        background-color: $black ; 
      }

      .footer_bottom_population{
        position: absolute;
        height: 310px;
        width: 105%;
        left: -15px;
        bottom: -10px;
        z-index: -1 ; 
        background-color: $black ; 
      }

      .footer_bottom_pager_population{
        position: absolute;
        height: 40px;
        width: 105%;
        left: -15px;
        bottom: 0;
        background-color: $black ; 
      }

      margin: 0px auto ; 
      padding-bottom: 50px;

      h2{
        color: $peach ;
        text-transform: none ; 
        font-weight: 700 ; 
        font-size: 26px;
      }

      .padding_factsheet{
        padding: 20px ;
      }

      header,footer{
        height: 300px ; 
        width: 100% ; 
        background-color: $black ; 
        color: $white ; 
        padding: 20px ;
        a{
          color: $white ; 
          text-decoration: none ;
        }
      }

      header.factsheet_head{
        background-size: 9% ; 
        background-repeat: no-repeat;
        background-position: bottom 20px right 20px ;
        padding: 20px 40px;
      }

      header{
        position: relative ;
        h1{
          color: $white ; 
          font-weight: 800 ; 
          font-size: 92px;
          position: absolute;
          width: 80%;
          line-height: 72px;
          bottom: 10px;
          left: 20px;
          text-transform: uppercase !important ; 
          &.title_2{
            font-size: 72px;
          }
          span{
            color: $peach ; 
            font-size: 28px;
          }
        }
        img{
          max-height: 85px;
          display: block; 
          text-align: center ; 
        }
        span.version{
          display: block;
          position: absolute;
          right: 19px;
          top: 77px;
          letter-spacing: 3px;
          border-top: solid 1px #fff;
          text-transform: uppercase;
          /* line-height: 17px; */
          font-size: 14px;
          font-weight: 900;
        }

        a#logoToday{
          display: block;
          right: 20px;
          top: 0px;
          text-decoration: none ; 
          position: absolute ; 
          img{
            max-height: 70px
          }

        }
        
      }

      .number_at_glance{
        width: 100%;
        height: 220px;
        color: #fff ; 
        padding: 20px ;
        border-radius: $border_radius ; 
        margin: 0 0 20px 0 ;
        box-shadow: $box_shadow ; 
        position: relative ;
        h2{
          color: #fff ; 
          font-size: 26px;
          font-weight: 900 ; 
        }

        span.metric{
          margin-top: 30px;
          display: block ;
          width: 100% ; 
          text-align: center ; 
          font-size: 22px;
          font-weight: 500;
          &.metric_in{
          }
        }

        span.value{
          display: block ;
          width: 100% ; 
          font-size: 42px;
          text-align: center ; 
          font-weight: 900 ; 
        }
        
        span.num{
          display: block ;
          width: 100% ; 
          text-align: right; 
          font-weight: 900 ; 
          font-size: 48px;
          position: absolute;
          bottom: 20px;
          right: 40px;
        }

        p.footnote{
          position: absolute ; 
          color: #000 ; 
          text-align: right ; 
          font-size: 11px; 
          bottom: -35px ;
          width: 100%; 
          right: 0px ; 
        }
      }

      .table-responsive{
        margin-left: -10px;
        thead{
          th{
            height: auto;
            font-size: 14px;
          }
        }
        tbody,thead{
          td,th{
            padding: 6px 8px;
          }
        }
      }

      table{
        border-radius: $border_radius ; 
        box-shadow: $box_shadow ; 
        font-family: $font_table ; 
        &.table-statistics{
          font-size: 16px !important;
          height: 622px;
        }
        tr.row_data{
          td{
            font-family: $font_table  ; 
          }
        }
        td,th{
          &.border_right{
            border-right: solid 1px #ccc !important;
            padding-right: 20px;
          }
        }
        th.val{
          text-align: right ; 
          font-family: $font_table  ; 
        }
        th.key,td.key{
          text-align: center ; 
          font-family: $font_table ; 
        }
        tr.top_row{
          color: #fff ; 
        }
        tr.row_line{
          border-top: solid 0px #000 ; 
        }
        td.row_title{
          padding-left:10px !important;
          font-weight: 600 ; 
          font-family: $font_table  ; 
        }

        td.val{
          text-align: right ; 
          line-height: 22px;
          font-family: $font_table ; 
        }
        td.val2{
          line-height: 11px;
          font-family: $font_table  ; 
        }
        th.val_left,td.val_left{
          text-align: left;
        }
        td{
          span.marker{
            display: inline-block;
            position: absolute;
            /* margin-right: 5px; */
            /* margin-left: 5px; */
            width: 15px;
            height: 15px;
            margin-top: -3px;
            margin-left: -5px;
            border-radius: 10px;
          }
        }
      }

      table.table-pie,table.table-pie-cancer{
        position: absolute ; 
        bottom: 40px;
        width: 100%;
        margin-left: 10px;
      }

      table.table-min.table{

        th.head_colspan{
          text-align: center ; 
          width: 25% ; 
        }

        th, td{
          padding: 8px;
          font-size: 13px;
        }

        tr.first_row{
          td{
            font-weight: 600 ; 
          }
        }
        tr.row_data{
          &.row_all_line{
            border-top: solid 2px #000 ;
          }
          &.row_all{
            font-weight: 800 ; 
          }
          td{
            text-align: right ; 
          }
          td.first_column{
            text-align: left ;
          }
        }

      }

      .table-map{
        width: 120px;
        top: 2px ; 
        
        position: absolute ;
        td,th{
          padding: 0px ;
          line-height: 1px;
          font-size: 7px; 
          text-align: right ; 
          &.val3{
            line-height: 8px;
          }
        }
        th{
          line-height: 12px;
        }

        &.table-map-1{
          right: 380px ; 
        }
        &.table-map-2{
          right: 250px ; 
        }
        &.table-map-3{
          right: 125px ; 
        }

        &.table-map-4{
          right: 2px ; 
        }
      }

      .block{
        padding: 0px 0 ;
        h3{
          font-weight: 800 ; 
          font-size: 22px;
          border-left-style: solid ; 
          border-left-width: 10px ; 
          padding-left: 15px;
        }
        p{
          line-height: 16px;
          font-size: 12px;
        }
      }

      .globe{
        border: $border_solid ; 
        width: 100%;
        padding: 20px 20px 20px 10px ;
        background-color: #fff ; 
        border-radius: $border_radius ; 
        box-shadow: $box_shadow ; 
        position: relative;
        p.pop_incl{
          position: absolute;
          font-size: 12px ; 
          left: 20px ; 
          width: 95%; 
        }
        img{
          max-height: 380px;
          display: block; 
          margin: auto ; 
        }
      }

      .graph{
        background-color: #fff ; 
        border: $border_solid ; 
        width: 100%;
        padding: 20px ;
        position: relative ;
        border-radius: $border_radius ; 
        box-shadow: $box_shadow ; 
        margin-bottom: 20px;
        h3{
          position: absolute;
          bottom: 0 ;
          width: 100% ; 
          font-size: 12px;
          font-weight: 600;
          padding: 2px 0 ; 
          text-align: center;
          margin-left: -10px;
          padding-right: 15px;
        }
        &.graph-title-top{
          h3{
            bottom: auto ; 
            top: 10px ; 
          }
          .table-responsive{
            margin-top: 15px;
          }
        }
      }

      a.hyperlink{
        display: block ; 
        position: relative;
        color: #000 ;

        h2.sub_title{
          font-size: 18px ; 
          color: #000 ; 
          text-decoration: none !important; 
          margin: 20px 0 0 20px ;
          border-left: solid 3px #B05A3F ; 
          padding: 0 ;
          padding-left: 10px ; 
          height: 18px ; 
        }

        &:hover{
          h2,h3{
            text-decoration: none !important; 
          }
        }
        .pie{
          height: 630px;
          padding: 0px ;

          .pie-graph{
            height: 360px;
            svg{
              display: block ; 
              margin: auto ; 
              text{
                font-size: 11px;
              }
              .sub_text_pie_value.sub_text_pie{
                display: none ; 
              }
              .pie_sum{
                display: none ; 
              }
            }
            table{
              text-decoration: none ; 
            }
          }
          h3{
            color: #2B3256 ; 
            text-decoration: none ; 
            &.sum{
              bottom: 255px;
              text-align: center ; 
            }
          }
          
        }

        .bars{
          margin-top: 0px ;
          height: 450px ; 
          svg{
            text{
              font-size: 11px
            }
            g.annotations{
              tspan{
                font-size: 11px
              }
            }
            g.legend{
              transform: translate(75px,-50px);
            }
            .grid line {
              stroke: #cccccc;
              stroke-width: 0.8px;
            }
            .grid.grid-ticks.grid-ticks-y line {
              stroke: #000;
            }
            .grid path{
              stroke-width: 0 ; 
            }
          }
        }

        .bars_ranking{
          height: 650px ;
          padding: 0 ;
          svg{
            text.bottom_legend{
              transform: translate(0px,10px);
            }
          } 
        }

        .bars3{
          height: 450px ; 
          svg{
            g.legend{
              transform: translate(150px,-50px);
            }
          }
        }

        .plot{
          height: 440px ; 
          table.table-continents{
            width: 200px; 
            position: absolute ;
            top: 32px;
            tr{
              td{
                border: none ;
                padding: 2px ;
                line-height: 16px;
                font-size: 11px;
              }
            }
          }
          svg{
            display: block; 
            position: absolute;
            right: 20px ;
            g.group_legend{
              display: none ; 
            }
            .grid line {
              stroke: #cccccc;
              stroke-width: 0.8px;
            }
            .grid path{
              stroke-width: 0 ; 
            }
            text.x_title,text.y_title{
              font-size: 11px;
            }
          }
        }

        .map{
          padding: 10px ; 
          svg{
            display: block; 
            margin: auto ; 
            g.map_group{
              transform: translate(0px,20px)!important;
            }
            /*g.mapLegendExtend{
              transform: translate(90px,355px);
            }*/
            g.map_sd,g.poly,g.line{
              /*display: none ; 
              opacity: 0;*/
              transform: translate(-50px,0px);
            }
            /*g.map_hd{
              opacity: 1!important;
              display: block!important;
            }
            path.country{
              stroke: #000 ;
              stroke-width: 0.4px;
            }

            path#code_ESH{
              fill: #7d7d7d;
            }*/
          }
          h3{
            /*width: 950px;*/
          }
        }
      }

      .globe{
        #map-container{
          svg{
            g.map_sd,g.poly,g.line{
              transform: translate(0px,35px)!important;
            }
            
            g.map_group{
              transform: translate(-10px, 0px) !important;
            }
            path#sphere{
              transform: translate(0px, 30px);
            }
          }
        }
      }

      

    }

    footer.factsheet_footer_pager{
      height: 40px;
      font-size: 12px;
      padding: 10px 20px!important;
      position: absolute;
    }

    /* mobile/tablet */
    &.factsheet_responsive{
      
      .factsheet_page{
        width: 100% ; 
        height: auto ;
        padding-bottom: 0 ;  

        .padding_factsheet{
          padding: 10px ;
        }

        header{
          height: 250px;

          h1{
            font-size: 2em ; 
            line-height: 1em;
          }
          img{
            max-height: 35px;
          }

          a#logoGCO{
            position: absolute;
            right: 0px; 
            top: -40px;
          }

          a#logoToday{
            left: 5px ;
            top: 10px;
            img{
              max-height: 45px;
            }
          }

          span.version{
            top: 65px;
            left: 5px;
            right: auto;
            letter-spacing: 0px;
          }
        }

        .number_at_glance{
          height: auto !important;
          min-height: 200px;
          padding: 10px ;
          span.metric{
            display: inline-block;
            width: 40%;
            text-align: left ; 
            font-size: 1.2em;
          } 
          span.value{
            display: inline-block;
            width: 60%;
          }
        }

        h2{
          padding: 10px 10px 0 10px ;
        }

        .graph{
          padding: 5px;
          h3{
            width: 100%;
            font-size: 12px;
            padding: 0px 0;
            text-align: left;
            margin-left: 5px;
            padding-right: 5px;
          }
        }

         a.hyperlink{
          .bars_ranking{
            svg{
              text.bottom_legend{
                transform: translate(-50px, 15px);
              }
            }
          }

          .pie{
            h3.sum{
              bottom: 270px;
            }
          }

          .pie.pie_cancer2{
            height: 600px;
            span.total{
              font-size: .8em;
              top: 120px;
            }
            span.total_num{
              top: 140px;
            }
          }

          .map{
            padding: 10px ; 
            svg{
              display: block; 
              margin: auto ; 
              g.map_group{
                transform: translate(20px, -45px) !important ;
              }
            }
          }
          .bars{
            svg{
              
              g.legend{
                  transform: translate(40px, -40px);
              }
            }
          }

          .bars3{
            svg{
              g.legend{
                transform: translate(-45px, -40px) ;
              }
            }
          }

        } // a.hyperlink

        table.table-pie{
          left: -5px;
        }

        

        .globe{
          #map-container{
            svg{
              g.map_group{
                transform: translate(0px, 0px) !important ;
              }
              g.annotation{
                display: none ; 
              }
            }
          }
        }


      }

      footer.factsheet_footer_pager{
        font-size: .8em;
      }

      footer{
        height: auto ; 
        position: relative;
        padding: 10px !important;

        h3{
          font-size: 1.4em;
        }

        #row_logos_footer{
          margin-top: 0 ; 
        }
        
        a#logo_gco{
          display: block; 
          position: absolute ;
          right: 0 ; 
          top: -30px ;
        }

        a#logo_cancer_today{
          margin-left: 0;
          margin-top: 20px;
        }

        span.copyright{
          width: 70%;
        }

        a#qr_self{
          right: 0px;
        }
      }

    }

  } // end factsheet-content

} // end factsheet


</style>